import { OG_DEFAULT } from "@/seo/ogImages";
import type { BlogFrontmatter } from "./types";

// Kein eigenes Motiv -> Default-OG-Bild (1200x630) aus src/seo/ogImages.ts.
const OG_IMAGE = OG_DEFAULT.image;

export const frontmatter: BlogFrontmatter = {
  title: "IP-Tracking vs. Cookies: Was 2026 im B2B DSGVO-konform geht",
  slug: "ip-tracking-vs-cookies-dsgvo",
  description:
    "IP-Tracking oder Cookies? Der Vergleich zeigt, welches Verfahren 2026 im B2B DSGVO-konform funktioniert und wie beide sich sinnvoll ergänzen.",
  primaryKeyword: "ip tracking dsgvo",
  secondaryKeywords: ["ip tracking vs cookies", "b2b tracking dsgvo"],
  author: "tim",
  datePublished: "2026-07-02",
  dateModified: "2026-07-02",
  image: OG_IMAGE,
  imageAlt: "Illustration: Vergleich von IP-Tracking und Cookies im B2B",
  internalLinks: ["/ip-tracking", "/blog/website-besucher-identifizieren-ip-tracking"],
  draft: true,
  kurzGesagt:
    "IP-basiertes Firmen-Tracking erkennt Organisationen ohne Einwilligung, weil keine Personen identifiziert werden; Cookies erfordern in der Regel ein Consent und erfassen Geräte. Für B2B ergänzen sich beide: Firmen-Signale zur Account-Erkennung, Cookies für einwilligungsbasierte Personalisierung.",
  faq: [
    { q: "Ist IP-Tracking ohne Cookie-Banner erlaubt?", a: "Stub: wird ausgearbeitet." },
    { q: "Was ändert sich 2026 rechtlich?", a: "Stub: wird ausgearbeitet." },
    { q: "Kann man beide Verfahren kombinieren?", a: "Stub: wird ausgearbeitet." },
  ],
};

export default function Article() {
  return (
    <>
      <p>
        <em>Entwurf / Gliederung. Volltext folgt.</em>
      </p>
      <h2>Gliederung</h2>
      <ul>
        <li>Wie Cookies funktionieren und warum sie Consent brauchen</li>
        <li>Wie IP-Firmen-Tracking funktioniert: Firma statt Person</li>
        <li>DSGVO-Vergleich: berechtigtes Interesse vs. Einwilligung</li>
        <li>These: Reichweite ≠ Pipeline. Account-Signale schlagen Klick-Tracking</li>
        <li>Tabelle: Wann welches Verfahren</li>
        <li>Empfehlung: sinnvolle Kombination im B2B-Stack</li>
      </ul>
    </>
  );
}
